import type { CancelToken } from 'axios';

import { hirerExpAxiosInstance } from './apiInstance';
import { DefaultDelay, retrier } from './apiRetry';
import type {
  PutQuestionsResponse,
  Questionnaire,
  SelectedQuestion,
} from './models';

export async function getQuestionnaire(
  id: string,
  cancelToken?: CancelToken,
): Promise<Questionnaire> {
  const questionnaireResponse = await retrier(
    () => hirerExpAxiosInstance().get(`/questionnaires/${id}`, { cancelToken }),
    {
      strategy: 'fixed',
      delayMs: DefaultDelay,
    },
  );
  return questionnaireResponse.data;
}

type ETag = {
  etag: string;
};

export interface SaveQuestionnaireOptions {
  questionnaireId: string;
  selectedQuestions: SelectedQuestion[];
  isVerifyBoosted?: boolean;
  versionNumber: string;
  cancelToken: CancelToken;
}

export async function saveQuestionnaire({
  questionnaireId,
  selectedQuestions,
  isVerifyBoosted,
  versionNumber,
  cancelToken,
}: SaveQuestionnaireOptions): Promise<PutQuestionsResponse & ETag> {
  const response = await retrier(
    () =>
      hirerExpAxiosInstance().put(
        `/questionnaires/${questionnaireId}/questions`,
        { selectedQuestions, isVerifyBoosted },
        {
          headers: { 'If-Match': versionNumber },
          cancelToken,
        },
      ),
    {
      strategy: 'fixed',
      delayMs: DefaultDelay,
    },
  );

  return { ...response.data, etag: response.headers.etag };
}
